import React, { useState, useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Modal,
  TextField
} from '@material-ui/core';

const inputPlaceholder = 
"Length\t\t\t0\n" +
"Chest\t\t\t0\n" +
"Waist\t\t\t0\n" +
"Shoulder\t\t0\n" +
"Sleeve\t\t\t0\n" +
"Armpit\t\t\t0\n" +
"Bottom\t\t\t0\n" +
"Neck\t\t\t/\n" +
"Note    "

const MeasurementsModal = ({edit, ...props}) => {

  const printRef = useRef();

  const [measureInput, setMeasureInput] = useState( edit ? inputPlaceholder : props.measureInput );

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    documentTitle: "Measurements"
  });

  const saveMeasurements = () => {
    props.addProductMeasurements(measureInput);
    props.closeModal();
  };

  return (
    <Modal
      open={props.open}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '10%'
      }}
    >
      <Card>
        <CardHeader
          subheader= {`${edit ? "Add" : "View"} the Measurements for this Product`}
          title="Measurements"
        />
        <Divider />
        <CardContent>
          { edit ?
            <TextField
              multiline
              fullWidth
              style={{ width: '260px' }}
              inputProps={{ maxLength: 250 }}
              variant="outlined"
              helperText="Enter Values next to their Fields"
              label="Measurements"
              name="measurements"
              onChange={(event) => setMeasureInput(event.target.value)}
              value={measureInput}
            /> :
            <div
              ref={printRef}
              style={{
                border: '1px solid lightgrey',
                borderRadius: '2%',
                width: '260px',
                paddingLeft: '10px',
                paddingRight: '10px'
              }}
            >
              <pre style={{ fontWeight: 'bold', fontSize: '18px' }}>     Measurements</pre>
              <pre style={{
                fontSize: '16px',
                whiteSpace: 'pre-wrap',
                wordWrap: 'break-word',
                wordBreak: 'break-word'
              }}>
                {measureInput}
              </pre>
            </div>
          }
        </CardContent>
        <Divider />
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            p: 2
          }}
        >
          { edit ?
            <Button
              color="primary"
              variant="contained"
              onClick={saveMeasurements.bind(this)}
            >
              Save
            </Button> :
            <Button
              color="primary"
              variant="contained"
              onClick={() => {
                handlePrint();
                props.closeModal();
              }}
            >
              Print
            </Button>
          }
          <Button sx={{ mx: 1 }} onClick={props.closeModal}>
            Cancel
          </Button>
        </Box>
      </Card>
    </Modal>
  )
};

export default MeasurementsModal;